<div class="mainmenu" *ngIf="verticalMenu">
    <ul>
        <li *ngFor="let menu of verticalMenu;let i = index" [ngClass]="{'show': menu?.isOpen}">

            <ng-container *ngIf="menu.parentsubmenu; else WithoutParentSubMenu">
                <a href="javascript:void(0)" type="button" (click)="goTo(i)" translate>
                    <em [ngClass]="menu.iconClass" class="mr4"></em><span translate>{{menu.lable}}</span>
                    <em class="fas pull-right mt5 fa-chevron-down arw"> </em></a>
                <div class="dropdown-menu" [ngClass]="{'show': menu.isOpen}" >
                    <div >
                 <li *ngFor="let parentmenu of menu.parentsubmenu;let i = index">
                         <h3><span translate>{{parentmenu.name}}</span></h3>
                        <a class="dropdown-item" *ngFor="let psubmenu of parentmenu.submenu"
                            [routerLink]="[psubmenu.route]" routerLinkActive="active" translate>
                            <em [ngClass]="psubmenu.iconClass" class="mr5"></em>
                            <span translate>{{psubmenu.lable}}</span>
                        </a>
                </li>
            </div>
        </div>
            </ng-container>
            <ng-template #WithoutParentSubMenu>
                <ng-container *ngIf="menu.submenu; else WithoutSubMenu">
                    <a href="javascript:void(0)" type="button" (click)="goTo(i)" translate>
                        <em [ngClass]="menu.iconClass" class="mr4"></em><span translate>{{menu.lable}}</span>
                        <em class="fas pull-right mt5 fa-chevron-down arw"> </em></a>
                    <div class="dropdown-menu" [ngClass]="{'show': menu.isOpen}" >
                        <div >
                        <a class="dropdown-item" *ngFor="let submenu of menu.submenu"
                            [routerLink]="[submenu.route]" routerLinkActive="active" translate>
                            <em [ngClass]="submenu.iconClass" class="mr5"></em>
                            <span translate>{{submenu.lable}}</span>
                        </a>
                        </div>
                    </div>
                </ng-container>
                <ng-template #WithoutSubMenu>
                    <a (click)="goTo(i)" [routerLink]="[menu.route]" routerLinkActive="active" translate>
                        <em [ngClass]="menu.iconClass" class="mr4"></em><span translate>{{menu.lable}}</span>
                    </a>
                </ng-template>
            </ng-template>

        </li>
    </ul>

    <!-- <footer class="footer mt-auto">
        <p class="copyright clearfix m-0 m-3">
            Copyright &copy; <a href="https://www.autofacets.com/" class="">AutoFacets</a>,
            <span class="d-block d-sm-block">All rights reserved.</span> <span class="mt-2"> version : 1.0</span>
        </p>
    </footer> -->
    <a class="mt-auto" (click)="OpenReleaseNotes()">
        <p class="ver-info text-center">Version : {{latestVersionNumber}}</p>
      </a>
</div>